import React from "react";
import PageRoutes from "./routes";

function App() {
  return (
    <>
      <PageRoutes />
    </>
  );
}

export default App;
